module.exports = __webpack_public_path__ + "static/FluidGridLarge-6fa62efe15195643bcfe46f2e33ba35d.gif";